import React, { useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import NewScheduleEventModal from "./new.schedule.event.modal";
import { useScheduleEvents } from "../../../app/contexts/schedule.events.context";
import PrimaryButton from "../../../app/components/buttons/primary";

const Controls = ({ search = "", onSearch, clearSearch }) => {
  const [openNewSOEModal, setOpenNewSOEModal] = useState(false);
  const { id } = useParams();
  const { createNewSOEPlan, fetchSOEStudy } = useScheduleEvents();

  const redirect = async () => {
    await fetchSOEStudy(id);
  };

  const handleClick = async (soe) => {
    const soeEventData = {
      studyId: id ? parseInt(id) : id,
      scheduleOfEventsName: soe.scheduleOfEventsName,
      scheduleOfEventsDescr: soe.scheduleOfEventsDescr,
      scheduleOfEventsStatus: "Draft",
      visitIntervalType: soe.visitIntervalType,
      visitWindowIntervalType: soe.visitWindowIntervalType,
      protocolDate: soe.protocolDate,
      protocolVersion: soe.protocolVersion,
      currency: soe.currency // Add currency to the data being sent
    };
    await createNewSOEPlan(soeEventData, redirect);
  };

  return (
    <Container>
      <PrimaryButton onClick={() => setOpenNewSOEModal(true)}>
        Add New SOE
      </PrimaryButton>

      {openNewSOEModal && (
        <NewScheduleEventModal
          onContinue={handleClick}
          open={openNewSOEModal}
          onClose={() => setOpenNewSOEModal(false)}
        />
      )}
    </Container>
  );
};

export default Controls;

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 1em 0;
  gap: 1em;
  align-content: center;
`;